module["exports"] = [
  "კორპ. ##",
  "შენობა ###"
];
